import React, { useState } from "react";
import "./Generation_Section.css";

import icon1 from "../../../Assets/Home/Generation_Section/1.png";
import icon2 from "../../../Assets/Home/Generation_Section/2.png";
import icon3 from "../../../Assets/Home/Generation_Section/3.png";
import icon4 from "../../../Assets/Home/Generation_Section/4.png";

import roughEdge from "../../../Assets/Home/Generation_Section/roughedge.png";
import SparkleIcon from "../../../Assets/Icons/ai-star.png";
import ProducerLogo from "../../../Assets/Home/Generation_Section/pdlogo.png";
import InvestorsForm from "../../Forms/Investorsform/investorsform";

export default function Generation_Section() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <section id="future" className="generation-wrapper">

            {/* TOP CONTENT */}
            <div className="nextgen-wrapper">
                <div className="nextgen-tag">
                    <img src={SparkleIcon} alt="sparkle" />
                    Future Innovation
                </div>

                <h2 className="nextgen-title">The Next Generation</h2>
                <div className="nextgen-underline"></div>

                <p className="nextgen-desc">
                    Introducing <img src={ProducerLogo} alt="PRODUCER Tech" className="inline-logo" /> – the future of unmanned retail stores.
                    Revolutionary technology that will transform how customers shop and
                    businesses operate.
                </p>
            </div>

            {/* TOP ROUGH EDGE */}
            <img src={roughEdge} alt="" className="rough-edge top-edge" />

            {/* MAIN SECTION */}
            <div className="green-section">

                {/* LEFT CONTENT */}
                <div className="left-box">
                    <div className="eco-tag">
                        <img src={SparkleIcon} alt="sparkle" />
                        Complete AI Ecosystem
                    </div>

                    {/* LOGO REPLACED HERE */}
                    <img
                        src={ProducerLogo}
                        alt="PRODUCER Tech"
                        className="producer-logo"
                    />

                    <p className="producer-sub">The Future of Unmanned Stores</p>

                    <p className="producer-desc">
                        All four products work together as a unified ecosystem. Data flows
                        seamlessly between store operations, consumer interactions, delivery
                        logistics, and vendor management.
                    </p>

                    <button className="yellow-btn" onClick={() => setIsModalOpen(true)}>
                        Join Us as an Partner
                    </button>
                </div>

                {/* RIGHT CARDS */}
                <div className="card-grid">
                    <Card img={icon1} text="Unmanned Store Operations" />
                    <Card img={icon2} text="Original Dimension Recognition" />
                    <Card img={icon3} text="Entity Comparison Technology" />
                    <Card img={icon4} text="Automated Product Retrieval" />
                </div>

            </div>

            {/* BOTTOM ROUGH EDGE */}
            <img src={roughEdge} alt="" className="rough-edge bottom-edge" />

            <InvestorsForm
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </section>
    );
}

function Card({ img, text }) {
    return (
        <div className="card">
            <img src={img} alt="" />
            <p>{text}</p>
        </div>
    );
}
